//src/components/api/suppliersApi.js

import { authFetch } from "./api";



const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const BASE = `${BASE_URL}/api/suppliers/suppliers/`;

export const getSuppliers = async () => {
  const res = await authFetch(BASE);
  return res.json();
};

export const createSupplier = async (data) => {
  return authFetch(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};

export const updateSupplier = async (id, data) => {
  return authFetch(`${BASE}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};

export const deleteSupplier = async (id) => {
  return authFetch(`${BASE}${id}/`, {
    method: "DELETE",
  });
};
